const state = () => ({
  list: []
});

const getters = {
  list: state => state.list
};

const mutations = {
  setList(state, payload) {
    state.list = Array.isArray(payload) ? payload : [];
  }
};

const actions = {
  async load({ commit, dispatch, rootGetters }, { locale }) {
    if (rootGetters['forms/medicalCategories/list']?.length) {
      return;
    }

    const hasValidToken = await dispatch('soulodyApi/ensureValidToken', null, { root: true });
    if (!hasValidToken) {
      return;
    }

    try {
      const data = await this.$soulodyApi.get('medical-categories', {
        params: { locale },
        skipSoulodyTokenEnsure: true
      });
      commit('setList', data.items);
    } catch (err) {
      dispatch('errorModal/handleError', { error: err, code: '0x00000066' }, { root: true }); //thrown with users that have AT present and token should be valid
    }
  }
};

export const medicalCategories = { namespaced: true, state, getters, mutations, actions };
